import * as React from "react";
import { IconName } from "@fortawesome/pro-light-svg-icons";
import { IMicroAppFeature } from "../types";
import { onNavigate } from "../../../config/routes";
import { buildLogicLayerNavPath } from "../../../config/constants";
import { IconButton } from "../../../components/mui-extended/mui-icon-button";
import { Tooltip } from "./tooltip";
import { INavNode, INavigationConfig } from "../../administration/partials/navigation-menu-section";
import { useFeatureAccessContext } from "../../../context/FeatureAccessContext";

interface IProps {
  navigationConfigs: INavigationConfig[];
  microAppFeature?: IMicroAppFeature;
}

export const NavigationToolbarItem: React.FC<IProps> = ({ navigationConfigs, microAppFeature }) => {
  const featureAccess = useFeatureAccessContext();
  if (!microAppFeature) return null;
  return (
    <>
      {navigationConfigs.map((config) => {
        const rootChildren = (config.children || []) as INavNode[];

        const visibleGroups = rootChildren
          .filter((node) => node.type === "folder" && node.isVisible && featureAccess?.canAccess(node.name))
          .sort((a, b) => a.order - b.order);

        return visibleGroups.map((group) => {
          const iconParts = group.icon.split(" ");
          const iconName = (iconParts.length > 1 ? iconParts[1].replace("fa-", "") : iconParts[0].replace("fa-", "")) as IconName;

          return (
            <Tooltip title={group.name} placement="right" arrow key={group.id}>
              <nav>
                <IconButton
                  variant="primary"
                  icon={iconName}
                  onClick={() =>
                    onNavigate(
                      microAppFeature.microapp,
                      `${buildLogicLayerNavPath(config.id, group.path)}`,
                      microAppFeature.domain,
                    )
                  }
                />
              </nav>
            </Tooltip>
          );
        });
      })}
    </>
  );
};
